export default __webpack_public_path__ + "static/media/do_balance.3ecc0f71.png";